var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12175_5212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5429 5.61852H13.9287V17.503H20.5429V5.61852Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3496 11.5608C14.3496 9.25109 15.4205 7.04637 17.2263 5.61855C13.9507 3.03587 9.1843 3.6028 6.60162 6.89939C4.03994 10.175 4.60687 14.9204 7.90346 17.5031C10.6541 19.6658 14.4966 19.6658 17.2473 17.5031C15.4205 16.0752 14.3496 13.8705 14.3496 11.5608Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4675 11.5608C29.4675 15.7393 26.087 19.1199 21.9085 19.1199C20.2077 19.1199 18.5699 18.5529 17.2471 17.5031C20.5227 14.9204 21.0896 10.175 18.5069 6.87839C18.129 6.41645 17.709 5.9755 17.2471 5.61855C20.5227 3.03587 25.2891 3.6028 27.8507 6.89939C28.9006 8.22222 29.4675 9.86002 29.4675 11.5608Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12175_5212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.8,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.adba683736e9a169d6ba6ee17e7a10b1.svg";
export { ForwardRef as ReactComponent };